export default {
      id: "ic_meteo-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_meteo-usage",
      toString: function () {
        return this.url;
      }
    }